import 'magnific-popup';

$(() => {
  /**
   * ポップアップを開く
   * @param idName 発火元になる要素のid名
   */
  const opneMagnificPopup = idName => {
    $.magnificPopup.open({
      items: {src: '#' + idName},
      type: 'inline',
      fixedContentPos: true
    }, 0);
  };

  /**
   * 削除ダイアログを開く
   */
  $('.js-remove-blog-article').on('click', function (e) {
    e.preventDefault();

    const title = $(this).data('blog-article-title');
    const id = $(this).data('blog-article-id');
    const url = '/delete_blog/' + id;

    $('.js-title-string').text(title);
    $('#popup_confirm > .btn_area > .delete').attr('href', url);

    opneMagnificPopup('popup-remove-blog-article');
  });

  /**
   * 確認ダイアログを閉じる
   */
  $('.back').on('click', function () {
    $.magnificPopup.close();
  });
});